import { render, staticRenderFns } from "./CampaignsData.vue?vue&type=template&id=5e76cdd3&scoped=true&"
import script from "./CampaignsData.vue?vue&type=script&lang=ts&"
export * from "./CampaignsData.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignsData.vue?vue&type=style&index=0&id=5e76cdd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e76cdd3",
  null
  
)

export default component.exports